import * as React from 'react';

import { Button, LinkButton } from '@cian/ui-kit';

/** Компонент заглушка для загрузки тем кнопок для редактора */
export const ButtonThemes: React.FC = () => {
  return (
    <div style={{ display: 'none' }}>
      <Button theme="fill_error_primary" />
      <Button theme="fill_error_secondary" />
      <Button theme="fill_primary" />
      <Button theme="fill_secondary" />
      <Button theme="fill_success_primary" />
      <Button theme="fill_success_secondary" />
      <Button theme="fill_warning_primary" />
      <Button theme="fill_warning_secondary" />
      <Button theme="fill_white_primary" />
      <Button theme="fill_white_secondary" />
      <Button theme="stroke_primary" />
      <Button theme="stroke_secondary" />
      <Button theme="stroke_white_secondary" />
      <LinkButton theme="fill_error_primary" />
      <LinkButton theme="fill_error_secondary" />
      <LinkButton theme="fill_primary" />
      <LinkButton theme="fill_secondary" />
      <LinkButton theme="fill_success_primary" />
      <LinkButton theme="fill_success_secondary" />
      <LinkButton theme="fill_warning_primary" />
      <LinkButton theme="fill_warning_secondary" />
      <LinkButton theme="fill_white_primary" />
      <LinkButton theme="fill_white_secondary" />
      <LinkButton theme="stroke_primary" />
      <LinkButton theme="stroke_secondary" />
      <LinkButton theme="stroke_white_secondary" />
    </div>
  );
};
